import { reduceSeriesToValue, reduceSeriesToValuePreviousPeriod } from "../lib"

export const topServicesMapper = (
  data,
  days,
  currentMetricDate,
  comparisonDate,
  timePeriodMetric
) => {
  const currentDailyMetric = data.current.metrics.find(
    metric => metric["metric_date"] === currentMetricDate
  )
  const comparisonDailyMetric = data.comparison.metrics.find(
    metric => metric["metric_date"] === comparisonDate
  )

  return {
    worksWithData: data.works_with_metrics.map(worksWith => {
      const currentWorksWithMetric = worksWith.metrics.find(
        metric => metric["metric_date"] === currentMetricDate
      )
      const comparisonWorksWithMetric =
        worksWith.metrics.find(
          metric => metric["metric_date"] === comparisonDate
        ) || {}
      return {
        channel: {
          brand_color: worksWith.works_with_channel.brand_color,
          name: worksWith.works_with_channel.name,
          monochrome_image_url: worksWith.works_with_channel.monochrome_image_url,
          module_name: worksWith.works_with_channel.module_name,
        },
        activeUsers: currentWorksWithMetric[`active_users_${timePeriodMetric}`],
        activeUsersLastPeriod:
          comparisonWorksWithMetric[`active_users_${timePeriodMetric}`],
        activeUsersAllTime: currentWorksWithMetric.active_users_all_time,
        engagement: reduceSeriesToValue(
          worksWith.metrics,
          days,
          "service_engagement_daily"
        ),
        engagementLastPeriod: reduceSeriesToValuePreviousPeriod(
          worksWith.metrics,
          days,
          "service_engagement_daily"
        ),
      }
    }),
    firstTimeUsers:
      currentDailyMetric[
        `first_time_service_connections_in_${timePeriodMetric}`
      ],
    firstTimeUsersLastPeriod:
      comparisonDailyMetric[
        `first_time_service_connections_in_${timePeriodMetric}`
      ],

    totalServices:
      currentDailyMetric[`first_time_service_connections_all_time`],
    totalServicesLastPeriod:
      comparisonDailyMetric[`first_time_service_connections_all_time`],
  }
}
